import { ServicesURL } from "@utils/utilsApi";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PagesID } from "@utils/utilsConfigurations";

const UseCustomConfigBasedOnTableOverall = (
  type: string,
): {
  formatDataBasedOnType: any;
  getTranslation: () => string;
  getConfigBasedOnType: any;
  getEndpointBasedOnType: string;
  getNavigationModuleBasedOnType: (row: any) => string;
  getEndpointFatherDetailBasedOnType: any;
} => {
  const { id, idPath, idCourse, idUser } = useParams();
  const { pathname } = useLocation();

  const getConfigBasedOnType = () => {
    switch (type) {
      case "paths-standalone":
        return PagesID["corporate.catalog.path.overall"];
      case "courses-standalone":
        return PagesID["corporate.catalog.courses.overall"];
      case "activities-standalone":
        return PagesID["corporate.catalog.activity.overall"];
      case "associated-activities":
        if (pathname.includes("enrolled-to")) {
          return PagesID["corporate.users.los.overall"];
        }
        return PagesID["corporate.catalog.children.overall"];
      case "associated-los":
        if (pathname.includes("enrolled-to")) {
          return PagesID["corporate.users.los.overall"];
        }
        return PagesID["corporate.catalog.children.overall"];
      case "enrolled-to":
        return PagesID["corporate.users.los.overall"];
      default:
        return PagesID["corporate.users.los.overall"];
    }
  };

  const getTranslation = () => {
    switch (type) {
      case "paths-standalone":
        return "path.overall";
      case "courses-standalone":
        return "courses.overall";
      case "activities-standalone":
        return "activity.overall";
      case "associated-activities":
      case "associated-los":
        return "modules.overall";
      case "enrolled-to":
        return "enrolled-to.overall";
      default:
        return "path.overall";
    }
  };

  const formatDataBasedOnType = (data: any) => {
    return data.map((element: any) => {
      switch (type) {
        case "paths-standalone":
          return { ...element, type: "PATH", category: element.type };
        case "courses-standalone":
          return { ...element, type: "COURSE", category: element.type };
        case "activities-standalone":
          return { ...element, type: "ACTIVITY", category: element.type };
        default:
          return { ...element };
      }
    });
  };

  const getEndpointBasedOnType = useMemo(() => {
    switch (type) {
      case "paths-standalone":
        return ServicesURL.getPaths.replace(":idCorporate", id || "1");
      case "courses-standalone":
        return `${ServicesURL.getCourses.replace(":idCorporate", id || "1")}?is_standalone=true`;
      case "activities-standalone":
        return `${ServicesURL.getActivities.replace(":idCorporate", id || "1")}?is_standalone=true`;
      case "associated-los":
        if (pathname.includes("enrolled-to")) {
          return `${ServicesURL.getPathChildren.replace(":idCorporate", id || "1").replace(":idPath", idPath || "")}?student_id=${idUser}`;
        }
        return `${ServicesURL.getPathChildren.replace(":idCorporate", id || "1").replace(":idPath", idPath || "")}`;
      case "associated-activities":
        if (pathname.includes("enrolled-to")) {
          return `${ServicesURL.getCourseChildren.replace(":idCorporate", id || "1").replace(":idCourse", idCourse || "")}?student_id=${idUser}`;
        }
        return `${ServicesURL.getCourseChildren.replace(":idCorporate", id || "1").replace(":idCourse", idCourse || "")}`;
      case "enrolled-to":
        return `${ServicesURL.getLOBasedOnStudentId.replace(":idCorporate", id || "1").replace(":studentId", idUser || "")}`;
      default:
        return "";
    }
  }, [type]);

  const getEndpointFatherDetailBasedOnType = useMemo(() => {
    switch (type) {
      case "associated-los":
        return `${ServicesURL.getPaths.replace(":idCorporate", `${id}`)}`;
      case "associated-activities":
        return `${ServicesURL["learning-catalogue"]}/${id}/learning-objects/courses`;
      default:
        return undefined;
    }
  }, [type]);

  const getNavigationModuleBasedOnType = (row: any) => {
    switch (type) {
      case "paths-standalone":
        return `${row?.id || row?.activity_id}/associated-los`;
      case "courses-standalone":
        return `${row?.id || row?.activity_id}/associated-activities`;
      case "associated-los":
        return `${row?.id || row?.activity_id}/associated-activities`;
      case "enrolled-to":
        if (row.type === "PATH") {
          return `${row?.id || row?.activity_id}/associated-los`;
        } else {
          return `${row?.id || row?.activity_id}/associated-activities`;
        }
      default:
        return "";
    }
  };

  return {
    getTranslation,
    formatDataBasedOnType,
    getConfigBasedOnType,
    getEndpointBasedOnType,
    getNavigationModuleBasedOnType,
    getEndpointFatherDetailBasedOnType,
  };
};

export default UseCustomConfigBasedOnTableOverall;
